/**
 * @namespace components
 */

import React from 'react';
import PropTypes from 'prop-types';

import { miniGazelle } from '../../../helpers';

import './ProductOverviewBlock.scss';

/**
 * @class ProductOverviewBlock
 *
 * Banner module that can be used as an advertising or warning style banner on pages
 *
 * @memberof components
 *
 *
 * @property {object} data - Primary object to insert data props into component
 * @property {string=} data.logicalName - Logical name of the module, used as the HTML node ID
 * @property {array} data.overviews - Array of overview items
 * @property {string=} data.overviews.headline - Headline text for each overviews
 * @property {string=} data.overviews.summary - Summary rich text describing the overview
 * @property {array} data.professionalBenefits - Array of overview items
 * @property {string=} data.professionalBenefits.statement - Statement text for each overviews
 * @property {string=} data.professionalBenefits.description - Description rich text describing the overview
 *
 * @example
 * return (
 *   <ProductOverviewBlock data={data} />
 * )
 */

const ProductOverviewBlock = (props = {}) => {
    const { data = {} } = props;
    const { logicalName, overviews = [], professionalBenefits = [] } = data;

    return (
        <div className="container-fluid module product-overview" id={logicalName}>
            <div className="row">
                <div className="container">
                    <div className="row">
                        <div className="col-md-2">
                            <h2>{miniGazelle.label('overview', true)}</h2>
                        </div>
                        <div className="col-md-10 overviews-wrapper">
                            {overviews.length > 0 &&
                                overviews.map((overview = {}, i) => {
                                    const { headline, summary } = overview;

                                    return (
                                        <div key={i} className="overviews-list-common overviews-list">
                                            {headline && (
                                                <h3
                                                    className="inner-content product-overviews-title h5"
                                                    dangerouslySetInnerHTML={{
                                                        __html: headline
                                                    }}
                                                />
                                            )}
                                            {summary && (
                                                <div
                                                    className="inner-content product-overviews-summary"
                                                    dangerouslySetInnerHTML={{
                                                        __html: summary
                                                    }}
                                                />
                                            )}
                                        </div>
                                    );
                                })}

                            {professionalBenefits.length > 0 &&
                                professionalBenefits.map((benefit = {}, i) => {
                                    const { statement, description } = benefit;

                                    return (
                                        <div key={i} className="overviews-list-common pro-benefits-list">
                                            {statement && (
                                                <h3
                                                    className="inner-content product-overviews-title h5"
                                                    dangerouslySetInnerHTML={{
                                                        __html: statement
                                                    }}
                                                />
                                            )}
                                            {description && (
                                                <div
                                                    className="inner-content product-overviews-summary"
                                                    dangerouslySetInnerHTML={{
                                                        __html: description
                                                    }}
                                                />
                                            )}
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ProductOverviewBlock.propTypes = {
    data: PropTypes.shape({
        logicalName: PropTypes.string,
        overviews: PropTypes.arrayOf(
            PropTypes.shape({
                headline: PropTypes.string,
                summary: PropTypes.string
            })
        ),
        professionalBenefits: PropTypes.arrayOf(
            PropTypes.shape({
                statement: PropTypes.string,
                description: PropTypes.string
            })
        )
    })
};

export default ProductOverviewBlock;
